import React from "react";

import LoginScreen from "@/screens/Authentication/LoginScreen";

export default function Main(): React.JSX.Element {
  return <LoginScreen />;
}
